var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { handleGraphqlError } from "@lululemon/auth-common";
import { CookieNames } from "../../cookies";
import { phoenixClient } from "../utils";
var TWO_MINUTES_FROM_NOW = Math.round(new Date().getTime() / 1000) + 120;
export var getHttpOnlyRefreshTokens = function (_a) {
    var logger = _a.logger, oktaConfig = _a.oktaConfig;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, data, errors, fullRefreshToken, partialRefreshToken, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, phoenixClient({
                            query: "\n          query getHttpOnlyCookies($fullCookieName: String!, $partialCookieName: String!) {\n            fullRefreshToken: getHttpOnlyCookie(name: $fullCookieName)\n            partialRefreshToken: getHttpOnlyCookie(name: $partialCookieName)\n          }\n        ",
                            variables: {
                                fullCookieName: CookieNames.LLL_REF_FULL,
                                partialCookieName: CookieNames.LLL_REF_PART
                            }
                        })];
                case 1:
                    _b = _c.sent(), data = _b.data, errors = _b.errors;
                    if (errors)
                        throw errors;
                    fullRefreshToken = void 0, partialRefreshToken = void 0;
                    if (data === null || data === void 0 ? void 0 : data.fullRefreshToken) {
                        fullRefreshToken = {
                            refreshToken: data.fullRefreshToken,
                            expiresAt: TWO_MINUTES_FROM_NOW,
                            scopes: oktaConfig.scopes,
                            tokenUrl: oktaConfig.tokenUrl || "",
                            authorizeUrl: oktaConfig.authorizeUrl || "",
                            issuer: oktaConfig.issuer || ""
                        };
                    }
                    if (data === null || data === void 0 ? void 0 : data.partialRefreshToken) {
                        partialRefreshToken = {
                            refreshToken: data.partialRefreshToken,
                            expiresAt: TWO_MINUTES_FROM_NOW,
                            scopes: oktaConfig.partialScopes,
                            tokenUrl: oktaConfig.tokenUrl || "",
                            authorizeUrl: oktaConfig.authorizeUrl || "",
                            issuer: oktaConfig.issuer || ""
                        };
                    }
                    return [2 /*return*/, { fullRefreshToken: fullRefreshToken, partialRefreshToken: partialRefreshToken }];
                case 2:
                    err_1 = _c.sent();
                    if (logger) {
                        handleGraphqlError({
                            error: new Error("Could not get httpOnly cookie. Reason: ".concat(err_1)),
                            tags: {
                                componentName: "graphql",
                                featureName: "auth-sdk",
                                functionName: "getHttpOnlyRefreshTokens"
                            },
                            logger: logger
                        });
                    }
                    throw err_1;
                case 3: return [2 /*return*/];
            }
        });
    });
};
export default getHttpOnlyRefreshTokens;
